var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/020c78c74567089d3a9668bd3a070d38.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c12ba9992c0b35f5e88018dacbf3f451.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cddbb9fc5361ad5915201b3886dce329.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e646183fd17654e16e9a847077b9414a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    